export enum EApplicationStatus {
    APPLIED = 'APPLIED',
    IN_PROGRESS = 'IN_PROGRESS',
    READY = 'READY',
    SELECTED = 'SELECTED',
    ACTIVATED = 'ACTIVATED',
    APPROVED = 'APPROVED'
}